window.addEventListener("scroll", (event) => {
  var element = document.getElementById("video-wrap");
  if(element != null){
      if (
        typeof document.getElementById("video-wrap") != "undefined" &&
        element.getAttribute("data-urls") != undefined &&
        document.getElementById("video-wrap").childNodes.length == 0
      ) {
        var lists = element.getAttribute("data-urls").split(",");
        var output = "";
        for (var i = 0; i < lists.length; i++) {
          output += `<div class="col-md-6 mb-md-0 mb-4">
            <div class="youtube-video">
    		<iframe src="${lists[i]}" allowfullscreen="" frameborder="0"></iframe>
                </div>
                </div>`;
        }
        element.innerHTML = `<div class="rows justify-content-center">${output}</div>`;
      }
    }
});

function modalIngredientsList(currentTarget) {
    let productTitle = currentTarget.getAttribute("data-productTitle") || null;
    let ingredientsList = currentTarget.getAttribute("data-ingredientsList") || null;

    const ingredientsListModal = document.getElementById('PopupModal-ingredientsList');
    const modal = ingredientsListModal.querySelector('.modal');
    modal.classList.add('open');

    const ingredientsListSection = ingredientsListModal.querySelector('.ingredientsList-section');
    ingredientsListSection.innerHTML = '<p class="letter-spacing fw-medium mb-3">' + productTitle + '</p>';
    ingredientsListSection.innerHTML += '<p class="font-size-md letter-spacing fw-light mb-0">' + ingredientsList + '</p>';
}
function closeIngredientsList() {
  const modal = document.querySelector('#PopupModal-ingredientsList .modal');
  modal.classList.remove('open');
}